import React, { forwardRef } from "react";
import { useTheme } from "@/contexts/theme/useTheme";
import { StyledPrimaryButton } from "./primary-button-styled";
import type { PrimaryButtonStyledProps } from "./primary-button-styled";
import { StyledSecondaryButton } from "./secondary-button-styled";

/** When set and a client theme is active, forces this variant. */
export type ThemeVariantOverride = "outlined" | "contained" | "text";

export type PrimaryButtonProps = PrimaryButtonStyledProps & {
  themeVariant?: ThemeVariantOverride;
  themeAsSecondary?: boolean;
};

const PrimaryButton = forwardRef<HTMLButtonElement, PrimaryButtonProps>(
  function PrimaryButton(
    { variant = "text", themeVariant, themeAsSecondary, ...props },
    ref
  ) {
    const { currentTheme } = useTheme();
    const isHpClient = currentTheme === "hp-client";
    const labelWrap = isHpClient ? (
      <span data-button-label>{props.children}</span>
    ) : (
      props.children
    );

    if (isHpClient && themeAsSecondary) {
      const secondaryVariant = themeVariant != null ? themeVariant : variant;
      return (
        <StyledSecondaryButton
          ref={ref}
          variant={secondaryVariant}
          data-sentence-case={isHpClient || undefined}
          {...props}
        >
          {labelWrap}
        </StyledSecondaryButton>
      );
    }

    const effectiveVariant =
      isHpClient && themeVariant != null ? themeVariant : variant;

    return (
      <StyledPrimaryButton
        ref={ref}
        variant={effectiveVariant}
        data-sentence-case={isHpClient || undefined}
        {...props}
      >
        {labelWrap}
      </StyledPrimaryButton>
    );
  }
);

export { PrimaryButton };
